__turbopack_context__.v({
  "carousel": "styles-module__6lSOnq__carousel",
  "thumbnail": "styles-module__6lSOnq__thumbnail",
});
